export const CHECKOUT_CAPTCHA_ID = 'subscription-checkout-captcha'
